import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Globals } from '../../globals'

@Component({
  selector: 'Reports',
  templateUrl: './Reports.component.html',
  styleUrls: ['./Reports.style.css']
})
export class ReportsComponent implements OnInit {

  _myGlobals: Globals;

  rptList = [];

  constructor(private globals: Globals) {
    this._myGlobals = globals;
  }

  ngOnInit(): void {
    switch (this._myGlobals?.spedSecurityUser?.roleName) {
      case 'SELPA':
      case 'SiteAdministrator':
      case 'SysAdmin':
        this.rptList = [
          { label: '100 - Possible Special Ed', command: (event: Event) => { this._myGlobals.reportSelected = '100' } },
          { label: '101 - Admin Placement Due', command: (event: Event) => { this._myGlobals.reportSelected = '101' } },
          { label: '105 - 30-Day Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '105' } },
          { label: '115 - Provider Caseload', command: (event: Event) => { this._myGlobals.reportSelected = '115' } },
          { label: '116 - Provider Progress', command: (event: Event) => { this._myGlobals.reportSelected = '116' } },
          { label: '117 - Progress Report By Date', command: (event: Event) => { this._myGlobals.reportSelected = '500' } },
          { label: '118 - Special Education Caseload', command: (event: Event) => { this._myGlobals.reportSelected = '118' } },
          { label: '120 - Service Registers', command: (event: Event) => { this._myGlobals.reportSelected = '120' } },
          { label: '121 - Certify Service Register', command: (event: Event) => { this._myGlobals.reportSelected = '121' } },

          { label: '125 - Services Delivered Summary', command: (event: Event) => { this._myGlobals.reportSelected = '125' } },
          { label: '126 - Services Delivered Detail', command: (event: Event) => { this._myGlobals.reportSelected = '126' } },
          { label: '126 - Services Delivered SELPA', command: (event: Event) => { this._myGlobals.reportSelected = '126S' } },


          { label: '130 - IEP Summary', command: (event: Event) => { this._myGlobals.reportSelected = '130' } },
          { label: '201 - Admin Service Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '201' } },
          { label: '202 - SpEd Students Disabilities', command: (event: Event) => { this._myGlobals.reportSelected = '202' } },
          { label: '310 - IEP Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '310' } },
          { label: '315 - Out of Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '315' } },
          { label: '320 - IEP Batch Print', command: (event: Event) => { this._myGlobals.reportSelected = '320' } },
          { label: '400 - Excel Based', command: (event: Event) => { this._myGlobals.reportSelected = '400' } },
          { label: '401 - Missing Student Ids', command: (event: Event) => { this._myGlobals.reportSelected = '401' } },
         /* { label: '117 - Progress Report By Date', command: (event: Event) => { this._myGlobals.reportSelected = '500' } },*/
          { label: 'Student Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '14' } }
        ]
        break;
      default:
        this.rptList = [
          { label: '100 - Possible Special Ed', command: (event: Event) => { this._myGlobals.reportSelected = '100' } },
          { label: '101 - Admin Placement Due', command: (event: Event) => { this._myGlobals.reportSelected = '101' } },
          { label: '105 - 30-Day Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '105' } },
          { label: '115 - Provider Caseload', command: (event: Event) => { this._myGlobals.reportSelected = '115' } },
          { label: '116 - Provider Progress', command: (event: Event) => { this._myGlobals.reportSelected = '116' } },
          { label: '118 - Special Education Caseload', command: (event: Event) => { this._myGlobals.reportSelected = '118' } },
          { label: '120 - Service Registers', command: (event: Event) => { this._myGlobals.reportSelected = '120' } },
          { label: '121 - Certify Service Register', command: (event: Event) => { this._myGlobals.reportSelected = '121' } },
          { label: '125 - Services Delivered Summary', command: (event: Event) => { this._myGlobals.reportSelected = '125' } },
          { label: '126 - Services Delivered Detail', command: (event: Event) => { this._myGlobals.reportSelected = '126' } },
          { label: '130 - IEP Summary', command: (event: Event) => { this._myGlobals.reportSelected = '130' } },
          { label: '201 - Admin Service Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '201' } },
          { label: '310 - IEP Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '310' } },
          { label: '315 - Out of Compliance', command: (event: Event) => { this._myGlobals.reportSelected = '315' } },
          { label: '320 - IEP Batch Print', command: (event: Event) => { this._myGlobals.reportSelected = '320' } }
        ]
        break;
    }

    
  }
}
